// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3694N","header":"MessagesList_header__Twl2T","chat":"MessagesList_chat__1lA_v"};